export const DASHBOARD_TYPE = {
  title: { base: '24px', md: '26px' },
  cardHeading: '14px',
  kpiNumber: { base: '15px', md: '16px', lg: '18px' },
  chartTableTitle: '14px',
  dataLabel: '11px',
  tableHeader: '11px',
  categoryLabel: '9px',
  axisLabel: 10,
};

export const DASHBOARD_SURFACE = {
  pageBg: '#F3F4F6',
  panelBg: '#F7F8FA',
  cardBg: '#FFFFFF',
  border: 'rgba(15, 23, 42, 0.08)',
  shadow: '0 1px 2px rgba(15, 23, 42, 0.06), 0 8px 24px rgba(15, 23, 42, 0.04)',
};

export const getSurfaceCardProps = () => ({
  bg: DASHBOARD_SURFACE.cardBg,
  borderRadius: '14px',
  border: '1px solid',
  borderColor: DASHBOARD_SURFACE.border,
  boxShadow: DASHBOARD_SURFACE.shadow,
});
